import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { usePageMeta } from "@/lib/site";

const COPY = {
  privacy: {
    eyebrow: "Legal",
    lines: ["Privacy Policy"],
    title: "Privacy Policy",
    body: [
      "Black Sky Builders respects your privacy. Information you submit through this website — including your name, contact details, property information, and project description — is used solely to respond to your inquiry, prepare for your consultation, and plan your project.",
      "We do not sell, rent, or share your personal information with third parties except as needed to coordinate your project (for example, with design professionals or financing resources you ask us to involve).",
      "This is a placeholder policy. A complete privacy policy will be published here before launch. Questions? Call (801) 598-1797 or email info@blackskybuilders.com.",
    ],
  },
  terms: {
    eyebrow: "Legal",
    lines: ["Terms of Use"],
    title: "Terms of Use",
    body: [
      "The content on this website is provided for general informational purposes by Black Sky Builders, Salt Lake City, Utah. Nothing on this site constitutes a bid, contract, lending offer, or guarantee of financing, approvals, rates, property values, or investment results.",
      "Black Sky Builders is a construction company, not a lender. Financing resources referenced on this site are provided by independent third parties under their own criteria.",
      "These are placeholder terms. Complete terms of use will be published here before launch. Questions? Call (801) 598-1797 or email info@blackskybuilders.com.",
    ],
  },
};

export default function Legal({ kind }) {
  const c = COPY[kind] || COPY.privacy;
  usePageMeta(c.title, c.body[0]);

  return (
    <div data-testid={`legal-${kind}-page`}>
      <PageHero eyebrow={c.eyebrow} lines={c.lines} />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-8 sm:py-24">
        {c.body.map((p, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <p className="mb-6 text-sm leading-relaxed text-mist sm:text-base">{p}</p>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
